/* Absolute Furniture Warehouse – homepage sections */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function aud(cents, whole) {
    var o = { style: 'currency', currency: 'AUD' };
    if (whole && cents % 100 === 0) { o.minimumFractionDigits = 0; o.maximumFractionDigits = 0; }
    return (cents / 100).toLocaleString('en-AU', o);
  }
  function toast(msg) {
    var t = document.getElementById('afwHomeToast');
    if (!t) { t = document.createElement('div'); t.id = 'afwHomeToast'; t.className = 'afw-home-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Hero carousel ---------- */
  function initHero(root) {
    var track = $('[data-afw-hero-track]', root); if (!track || track._afw) return; track._afw = true;
    var hero = track.parentNode, real = $$('.hero-slide', track), n = real.length;
    if (n < 2) return;
    var clone = real[0].cloneNode(true); clone.setAttribute('aria-hidden', 'true'); clone.tabIndex = -1; track.appendChild(clone);
    var dotsWrap = $('[data-afw-hero-dots]', root), dots = [];
    var DELAY = parseInt(root.getAttribute('data-delay'), 10) || 8000, timer = null, paused = false, startedAt = 0, remaining = DELAY, current = -1;
    hero.style.setProperty('--hero-delay', DELAY + 'ms');
    real.forEach(function (_, i) {
      var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1)); d.innerHTML = '<span class="fill"></span>';
      d.addEventListener('click', function () { go(i); restart(); }); dotsWrap.appendChild(d); dots.push(d);
    });
    function w() { return track.clientWidth; }
    function idx() { return Math.round(track.scrollLeft / w()); }
    function setDots(i, force) {
      i = i % n; if (i === current && !force) return; current = i;
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      void dotsWrap.offsetWidth; dots[i].classList.add('is-active');
    }
    function go(i, instant) { track.scrollTo({ left: i * w(), behavior: instant || reduced ? 'auto' : 'smooth' }); setDots(i); }
    function next() { var i = idx(); if (i >= n) { track.scrollTo({ left: 0, behavior: 'auto' }); i = 0; } go(i + 1); }
    function prev() { var i = idx(); if (i <= 0) { track.scrollTo({ left: n * w(), behavior: 'auto' }); i = n; } go(i - 1); }
    function tick() { next(); remaining = DELAY; schedule(); }
    function schedule() { clearTimeout(timer); if (reduced || paused) return; startedAt = Date.now(); timer = setTimeout(tick, remaining); }
    function pause() { if (paused) return; paused = true; clearTimeout(timer); remaining = Math.max(0, remaining - (Date.now() - startedAt)); hero.classList.add('is-paused'); }
    function resume() { if (!paused) return; paused = false; hero.classList.remove('is-paused'); schedule(); }
    function restart() { remaining = DELAY; setDots(current < 0 ? 0 : current, true); schedule(); }
    var settle;
    track.addEventListener('scroll', function () {
      setDots(idx()); clearTimeout(settle);
      settle = setTimeout(function () { if (idx() >= n) track.scrollTo({ left: 0, behavior: 'auto' }); }, 120);
    }, { passive: true });
    $('[data-afw-hero-next]', root).addEventListener('click', function () { next(); restart(); });
    $('[data-afw-hero-prev]', root).addEventListener('click', function () { prev(); restart(); });
    hero.addEventListener('mouseenter', pause); hero.addEventListener('mouseleave', resume);
    hero.addEventListener('focusin', pause); hero.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else if (!hero.matches(':hover')) resume(); });
    track.addEventListener('touchstart', restart, { passive: true });
    // Mouse drag to swipe
    var down = false, moved = false, sx = 0, sl = 0, startIdx = 0;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; startIdx = idx(); });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!down) return; down = false; if (!moved) return;
      var dx = e.clientX - sx, target = startIdx;
      if (dx < -w() * 0.12) target = startIdx + 1; else if (dx > w() * 0.12) target = startIdx - 1;
      track.classList.remove('is-dragging');
      if (target < 0) { track.scrollTo({ left: n * w() + track.scrollLeft, behavior: 'auto' }); target = n - 1; }
      go(Math.min(target, n)); restart();
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    window.addEventListener('resize', function () { go(idx() % n, true); });
    setDots(0, true); schedule();
  }

  /* ---------- Product tabs + quick add ---------- */
  function initTabs(root) {
    if (root._afw) return; root._afw = true;
    var tabs = $$('[data-afw-ptab]', root), grids = $$('[data-afw-pgrid]', root), link = $('[data-afw-shopall]', root);
    var hrefs = link ? [link.getAttribute('href'), link.getAttribute('data-alt') || link.getAttribute('href')] : [];
    var labels = link ? [link.getAttribute('data-label'), link.getAttribute('data-alt-label')] : [];
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.setAttribute('aria-selected', String(k === i)); x.tabIndex = k === i ? 0 : -1; });
        grids.forEach(function (g, k) { g.hidden = k !== i; });
        if (link) { link.href = hrefs[i]; link.textContent = labels[i] + ' →'; }
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var t = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; t.click(); t.focus();
      });
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-afw-qadd]'); if (!b) return;
      b.disabled = true;
      var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-afw-qadd')), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); return fetch(base + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-afw-cart-count]').forEach(function (c) { c.textContent = cart.item_count; var a = c.closest('a'); if (a) a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
          toast('Added ' + b.getAttribute('data-title') + ' to your cart');
        })
        .catch(function () { toast('Sorry, that could not be added. Please try again.'); })
        .then(function () { b.disabled = false; });
    });
  }

  /* ---------- Deal of the Week ---------- */
  function initDeal(root) {
    if (root._afw || !window.AFW || !window.AFW.currentDeal) return; root._afw = true;
    var d = window.AFW.currentDeal(); if (!d) return;
    root.hidden = false;
    var set = function (sel, fn) { var el = $(sel, root); if (el) fn(el); };
    set('[data-afw-deal-title]', function (el) { el.textContent = d.title; });
    set('[data-afw-deal-desc]', function (el) { el.textContent = d.text || ''; el.hidden = !d.text; });
    set('[data-afw-deal-now]', function (el) { el.textContent = 'Now ' + aud(d.price, true); });
    set('[data-afw-deal-was]', function (el) { el.hidden = !(d.compare > d.price); if (d.compare > d.price) el.textContent = 'Was ' + aud(d.compare, true); });
    set('[data-afw-deal-extra]', function (el) { el.hidden = !(d.extra > 0); if (d.extra > 0) el.textContent = 'Down an extra $' + d.extra + ' this week'; });
    set('[data-afw-deal-bnpl]', function (el) { el.textContent = 'or 4 × ' + aud(Math.round(d.price / 4)) + ' with Afterpay'; });
    set('[data-afw-deal-link]', function (el) { el.href = d.url; });
    set('[data-afw-deal-imgwrap] img', function (el) { if (d.image) { el.src = d.image; el.removeAttribute('srcset'); el.alt = d.title; el.hidden = false; } });
  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    if (root._afw) return; root._afw = true;
    var list = $('[data-afw-rv-list]', root), prev = $('[data-afw-rv-prev]', root), next = $('[data-afw-rv-next]', root);
    // afw.js's global initReviews() also scans every .rv-card on the page (it powers the same
    // read-more button on product pages). On the homepage both scripts run, so without this
    // shared guard each button gets two click listeners — toggling "is-open" twice per click,
    // which cancels itself out and makes the button look dead.
    $$('.rv-card', root).forEach(function (card) {
      if (card._afwInit) return; card._afwInit = true;
      var txt = $('.rv-text', card), more = $('.rv-more', card);
      if (txt.scrollHeight > txt.clientHeight + 2) { more.hidden = false; more.addEventListener('click', function () { var o = card.classList.toggle('is-open'); more.textContent = o ? 'Show less' : 'Read more'; }); }
    });
    if (!list) return;
    function step() { var c = $('.rv-card', list); return c ? c.offsetWidth + 20 : list.clientWidth; }
    function update() { prev.disabled = list.scrollLeft <= 2; next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2; }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    list.addEventListener('scroll', function () { clearTimeout(list._t); list._t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update); update();
  }

  /* ---------- Showrooms: live open/closed ---------- */
  function initStores(root) {
    if (root._afw || !window.AFW) return; root._afw = true;
    function upd() {
      $$('[data-afw-store]', root).forEach(function (el) {
        var name = $('h3', el).textContent, st = window.AFW.storeStatus([{ name: name, hours: el.getAttribute('data-hours') }]);
        var s = $('[data-afw-store-status]', el); if (!st.text) return;
        s.textContent = st.open ? 'Open now · until ' + st.text.split('until ')[1] : 'Closed · opens ' + st.text.split(' opens ')[1];
        s.classList.toggle('is-open', st.open);
      });
    }
    upd(); setInterval(upd, 60000);
  }

  function init() {
    $$('[data-afw-hero-root]').forEach(initHero);
    $$('[data-afw-ptabs-root]').forEach(initTabs);
    $$('[data-afw-deal-root]').forEach(initDeal);
    $$('[data-afw-rv-root]').forEach(initReviews);
    $$('[data-afw-stores-root]').forEach(initStores);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
